import React from "react";
import { FlatButton, TextField } from "material-ui";
import moment from "moment";

import connectToStores from "alt-utils/lib/connectToStores";
import ShiftActions from "../../../actions/ShiftActions";
import ShiftStore from "../../../stores/ShiftStore";

import CurrencyField from "../currency-field.jsx";
import LinkLike from "../link-like.jsx";
import BaseOverlay from "../overlays/base.jsx";

import { formatPrice } from "../../../util";

const BASE_STYLE = {
  marginLeft: 10,
  display: "inline-block",
  padding: "5px 10px",
  borderRadius: 5,
  background: "#fff",
  boxShadow: "0px 0px 7px 1px rgba(0,0,0,0.2)"
};

const NO_SHIFT_STYLE = {
  backgroundColor: "red",
  color: "#fff"
};

class ShiftTracking extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      forceOpen: false,
      enteredCash: 0,
      enteredNote: ""
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.shiftAction = this.shiftAction.bind(this);
  }

  static getStores() {
    return [ShiftStore];
  }

  static getPropsFromStores() {
    let state = ShiftStore.getState();
    return state;
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  componentWillMount() {
    ShiftActions.fetchCurrentShift.defer();
  }

  componentWillReceiveProps(props) {
    if (!props.isWorking && !props.currentShift && !this.state.modalOpen) {
      this.setState({ forceOpen: true }, () => {
        this.openModal();
      });
    }
  }

  openModal() {
    if (this.props.currentShift) {
      ShiftActions.fetchCurrentShift();
    }
    this.setState({ modalOpen: true });
  }

  closeModal() {
    this.setState({ modalOpen: false, forceOpen: false });
  }

  shiftAction() {
    const { currentShift } = this.props;
    ShiftActions[currentShift ? "closeShift" : "createShift"]({
      [`${currentShift ? "closing" : "starting"}_cash`]: this.state.enteredCash,
      [`${currentShift ? "closing" : "starting"}_note`]: this.state.enteredNote
    });
    this.setState({ modalOpen: false, forceOpen: false }, () => {
      this.setState({ enteredNote: "", enteredCash: 0 });
    });
  }

  render() {
    const { isWorking, hasFetchedForFirstTime, currentShift } = this.props,
      { forceOpen } = this.state;

    return (
      <div
        style={Object.assign(
          {},
          BASE_STYLE,
          hasFetchedForFirstTime && !currentShift && NO_SHIFT_STYLE
        )}
      >
        <BaseOverlay
          open={this.state.modalOpen}
          onRequestClose={!forceOpen && this.closeModal}
          useMuiDefaultStyle={true}
          dialogContentStyle={{ maxWidth: 300 }}
          actions={[
            <FlatButton
              label="Cancel"
              onTouchTap={
                forceOpen ? this.context.router.goBack : this.closeModal
              }
            />,
            <FlatButton
              primary={true}
              label={currentShift ? "Close current shift" : "Open new shift"}
              onTouchTap={this.shiftAction}
            />
          ]}
        >
          {currentShift ? (
            <div>
              <div style={{ marginBottom: 10 }}>
                Shift #{currentShift.short_id} opened{" "}
                {moment(currentShift.started_at).format("lll")}
                {currentShift.starting_cash || currentShift.starting_note
                  ? " with"
                  : ""}
                {currentShift.starting_cash
                  ? ` ${formatPrice(currentShift.starting_cash)} starting cash${
                      currentShift.starting_note ? " and" : ""
                    }`
                  : ""}
                {currentShift.starting_note
                  ? ` the note "${currentShift.starting_note}"`
                  : ""}
                .
              </div>
              {isWorking ? (
                <div>Loading expected closing cash...</div>
              ) : (
                <div>
                  Expected closing cash:{" "}
                  {formatPrice(currentShift.expected_cash)}
                </div>
              )}
            </div>
          ) : (
            <div>
              <h3 style={{ textAlign: "center" }}>New shift</h3>
              <div>
                You must open a new shift in order to launch box office sales.
              </div>
            </div>
          )}
          <CurrencyField
            autoFocus={true}
            value={this.state.enteredCash}
            floatingLabelText={`${
              currentShift ? "Actual closing" : "Starting"
            } cash`}
            floatingLabelFixed={true}
            placeholder="$0.00"
            onChange={e => this.setState({ enteredCash: e.target.value })}
          />
          <TextField
            value={this.state.enteredNote}
            floatingLabelText={`${currentShift ? "Closing" : "Shift"} note`}
            floatingLabelFixed={true}
            placeholder="n/a"
            onChange={e => this.setState({ enteredNote: e.target.value })}
          />
        </BaseOverlay>

        {!hasFetchedForFirstTime && !currentShift ? (
          <span style={{ color: "rgb(33,33,33)" }}>Loading shift...</span>
        ) : currentShift ? (
          <span>
            <strong>
              Shift #{currentShift.short_id} opened{" "}
              {moment(currentShift.started_at).format("LT")}
            </strong>{" "}
            &middot;{" "}
            <LinkLike onTouchTap={this.openModal}>Close shift</LinkLike>
          </span>
        ) : (
          <span>
            <strong>No current shift</strong> &middot;{" "}
            <LinkLike style={{ color: "#fff" }} onTouchTap={this.openModal}>
              Open new shift
            </LinkLike>
          </span>
        )}
      </div>
    );
  }
}

export default connectToStores(ShiftTracking);



// WEBPACK FOOTER //
// ./src/app/components/partials/box-office/box-office-shift-tracking.jsx